import React, { Component } from 'react'

import withCssClassName from '../with-css-class-name'

class FacebookIcon extends Component {
    render() {
        return (
            <svg {...this.props} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><path d="M14.5 0h-13C.675 0 0 .675 0 1.5v13c0 .825.675 1.5 1.5 1.5H8V9H6V7h2V6c0-1.653 1.347-3 3-3h2v2h-2c-.55 0-1 .45-1 1v1h3l-.5 2H10v7h4.5c.825 0 1.5-.675 1.5-1.5v-13c0-.825-.675-1.5-1.5-1.5z"/></svg>
        )
    }
}

export default withCssClassName(FacebookIcon)



// WEBPACK FOOTER //
// src/components/svg-icon/icons/facebook-icon.js